import { httpClient } from '@/infra/protocols/http';
import { IProjectDTO } from '@/modules/projects/dtos/project.dto';
import { IProject } from '@/modules/projects/entities/project.entity';
import { ProjectMapper } from '@/modules/projects/mappers/project.mapper';

export async function getExploreProjects(): Promise<GetExploreProjectsService.Response> {
  const response = await httpClient.get<IProjectDTO[]>(`/v1/projetos/explorar`);
  return response.map(ProjectMapper.toPresentation);
}

export namespace GetExploreProjectsService {
  export type Response = IProject[];
}
